import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '../../services/auth.service';

/**
 * Admin "Add new gateway" modal — takes a UID and calls /gateways/provision,
 * which dispenses a pool code and stores the code<->uid mapping. On success it
 * shows the generated activation code (to hand to the customer).
 */
@Component({
    selector: 'app-provision-gateway-modal',
    imports: [FormsModule],
    templateUrl: './provision-gateway-modal.component.html',
    styleUrl: './provision-gateway-modal.component.scss',
})
export class ProvisionGatewayModalComponent {
    uid = '';
    submitting = false;
    provisionedCode: string | null = null;
    error: string | null = null;

    constructor(
        public activeModal: NgbActiveModal,
        private authService: AuthService,
    ) { }

    submit(): void {
        const uid = this.uid.trim();
        if (!uid || this.submitting) return;

        this.submitting = true;
        this.error = null;
        this.authService.provisionGateway(uid).subscribe({
            next: (res) => {
                this.submitting = false;
                this.provisionedCode = res?.code ?? null;
            },
            error: (err) => {
                this.submitting = false;
                this.error = 'Unable to add gateway. Please try again.';
                console.error('[provision] error:', err);
            },
        });
    }
}
